import React from 'react';
import { cn } from '@/utils/cn';
import { menuPage } from '@/data/content';

interface AvailabilityStripProps {
    pickedDate: Date | null;
    hasLunch: boolean;
    hasDinner: boolean;
    hasPickup: boolean;
    hasDelivery: boolean;
}

const AvailabilityStrip: React.FC<AvailabilityStripProps> = ({
    pickedDate,
    hasLunch,
    hasDinner,
    hasPickup,
    hasDelivery,
}) => (
    <div className="mt-4 pt-3 border-t border-gray-100 dark:border-gray-700 flex flex-col gap-2 text-[10px] text-app-muted font-medium">
        <span className="text-[10px] uppercase tracking-wider font-semibold opacity-60">Options disponibles</span>
        <div className="flex items-center justify-between gap-1 w-full whitespace-nowrap">
            <div
                className={cn('flex items-center gap-1 transition-opacity duration-200', pickedDate && !hasLunch && 'opacity-30')}
            >
                <span className="text-[12px] leading-none">☀️</span>
                <span>{menuPage.filter_period_lunch}</span>
            </div>
            <div
                className={cn('flex items-center gap-1 transition-opacity duration-200', pickedDate && !hasDinner && 'opacity-30')}
            >
                <span className="text-[12px] leading-none">🌙</span>
                <span>{menuPage.filter_period_dinner}</span>
            </div>
            <div
                className={cn('flex items-center gap-1.5 transition-opacity duration-200', pickedDate && !hasPickup && 'opacity-30')}
            >
                <span className="text-[12px] leading-none">🏠</span>
                <span>{menuPage.filter_pickup}</span>
            </div>
            <div
                className={cn('flex items-center gap-1.5 transition-opacity duration-200', pickedDate && !hasDelivery && 'opacity-30')}
            >
                <span className="text-[12px] leading-none">🛵</span>
                <span>{menuPage.filter_delivery}</span>
            </div>
        </div>
    </div>
);

export default AvailabilityStrip;
